import React, { PropTypes, Component } from 'react';
import EntitiesListHorizontolWebsiteContainer from './EntitiesListHorizontolWebsiteContainer';
import Notification from './Notification';
import { loadMoreWebsites } from '../actions/WebsiteLoadCreator';

class Websites extends Component {
  static propTypes = {
    entities: PropTypes.array.isRequired
  }

  static defaultProps = {
    entities: []
  }

  static contextTypes = {
    executeAction: React.PropTypes.func
  }

  render() {
    var entites = this.props.entities;
    return (
      <div className='container-fluid' style={ { 'padding': '0px', 'overflow': 'hidden' } }>
        <div className='row-fluid clearfix'>
          <Notification notifications={ [] } />
          <div className='col-md-9'>
            <div className='container-fluid container-border'>
              <div className='row-fluid row1'>
                <div className='col-md-12' style={ { 'paddingLeft': '0px' } }>
                  <a className='category-breadcumb' style={ { 'paddingBottom': '0px' } } href='/'>
                                              Home
                                          </a> /
                  <a className='category-breadcumb' style={ { 'paddingBottom': '0px' } } href='/services'>
                                              WEBSITES
                                          </a>
                  <div className='category-title landing-title'>
                    WEBSITES
                  </div>
                </div>
              </div>
              { entites.map(function(entity, index) {
                  return (
                    <div>
                      <EntitiesListHorizontolWebsiteContainer entities={ entity } />
                      { (index !== entites.length - 1) && (
                        <div className='row-fluid'>
                          <div className='col-md-12 item-padding'>
                            <div className='category-border'></div>
                          </div>
                        </div>
                        ) }
                    </div>
                    );
                }) }
              <div className='row-fluid'>
                <div className='col-md-12 loadmore'>
                  <div className='loadmore-button' onClick={ this.loadWebsites.bind(this, entites) }>load more</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      );

  }
  loadWebsites(entities) {
    this.context.executeAction(loadMoreWebsites, {
      limit: entities.length
    });
  }
}

module.exports = Websites;


// WEBPACK FOOTER //
// ./src/components/Websites.js